import { render, staticRenderFns } from "./ExpeditionDetailInAppointment.vue?vue&type=template&id=3c15d19b"
import script from "./ExpeditionDetailInAppointment.vue?vue&type=script&lang=js"
export * from "./ExpeditionDetailInAppointment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports